import { render, staticRenderFns } from "./index.vue?vue&type=template&id=516a9c4e&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=516a9c4e&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "516a9c4e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/drone/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('516a9c4e')) {
      api.createRecord('516a9c4e', component.options)
    } else {
      api.reload('516a9c4e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=516a9c4e&scoped=true", function () {
      api.rerender('516a9c4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/service/mac-version/index.vue"
export default component.exports